import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-multiline-phone-cell',
  template: `
    <div class="multiline-cell">
      <ul>
        @for (value of dataContext; track $index) {
          <li>
            @if (value) {
              <a [href]="'tel:' + value" (click)="$event.stopPropagation()">{{ value }}</a>
            } @else {
              &nbsp;
            }
          </li>
        }
      </ul>
    </div>
  `,
  styleUrls: ['./multiline-text-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultilinePhoneCellComponent {
  @Input() dataContext: string[] = [];
}
